export * from './Favoritos.nav';